// extracted by mini-css-extract-plugin
export default {"text":"TextProperty_text__mUaeJ","normal":"TextProperty_normal__2Y7PV","small":"TextProperty_small__UBpW4"};